/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const Popup = (() => {
	const DOM    = {};
	let open;

	const cacheDOM      = () => {
		DOM.openButton  = document.getElementById( "open-button" );
		DOM.popup  = document.getElementById( "popup" );
		DOM.closeButton = document.getElementById( "close-button" );
	};

	const closePopupButtonNotClicked = event => {
		if (open !== 0) {
			if ( ! event.target.closest( ".popup" )) {
				closePopup( event );
			}
		}
	};

	const openPopup = event => {
		event.preventDefault();
		event.stopPropagation();
		DOM.popup.classList.add( "open" );
		open = 1;
		document.addEventListener( "click", closePopupButtonNotClicked );
	};

	const closePopup = event => {
		event.preventDefault();
		DOM.popup.classList.remove( "open" );
		open = 0;
		document.removeEventListener( "click", closePopupButtonNotClicked );
	};

	const eventListeners = () => {
		DOM.openButton.addEventListener( "click", openPopup );
		DOM.closeButton.addEventListener( "click", closePopup );
	};

	function init() {
		cacheDOM();
		eventListeners();
	}

	return {
		init
	};
})();

export default Popup;
